import React, { ReactElement, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { InboxTypesContactAutocompleteProps } from "./types";
import { handleInboxUpdate } from "./utils";
import { FormikValues } from "formik/dist/types";
import SelectOrCreateContactsAutocompleteField from "../../../contacts/autocomplete";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { INBOX_STATUS } from "../../utils";
import { PermissionsUpdate } from "../../../../constants";
import useAccessControl from "../../../../hooks/useAccessControl";

/* istanbul ignore next */
const InboxContactAutocomplete = ({
  inboxData,
  setSnackbarData,
  defaultPreloadedData,
}: InboxTypesContactAutocompleteProps): ReactElement => {
  const { t } = useTranslation();
  const { can } = useAccessControl();
  const [outState, setOutState] = useState();

  useEffect(() => {
    outState && (inboxData.contact = outState);
  }, [outState]);

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          contact_id: inboxData.contact ? inboxData.contact.id : "",
          contact: inboxData.contact ? inboxData.contact : "",
        }}
        onSubmit={handleInboxUpdate({ id: inboxData.id, setSnackbarData, t })}
      >
        {({
          handleSubmit,
          handleChange,
          isSubmitting,
          handleBlur,
          touched,
          errors,
          status,
          setFieldValue,
          values,
          submitForm,
        }: FormikValues): ReactElement => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={6} columns={12}>
              <Grid item xs={12} sm={12} mr={20}>
                <SelectOrCreateContactsAutocompleteField
                  {...{
                    errors,
                    values,
                    touched,
                    status,
                    handleBlur,
                    handleChange,
                    setFieldValue,
                    isSubmitting,
                    submitForm,
                  }}
                  size="small"
                  sx={{ mt: 4 }}
                  variant={"standard"}
                  label={null}
                  disableUnderline={true}
                  table={true}
                  displayOnlyFullName={true}
                  placeholder={t("createContact.searchContact")}
                  disabled={inboxData.status.code === INBOX_STATUS.COMPLETED}
                  editPermissions={can(PermissionsUpdate.INBOX)}
                  disabledTooltipText={"inbox.pleaseMoveToProgress"}
                  showContactFullTooltip={true}
                  addIconSx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 4,
                  }}
                  setOutState={setOutState}
                  defaultPreloadedData={defaultPreloadedData}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  );
};

export default InboxContactAutocomplete;
